// ─────────────────────────────────────────────
// HubWire Validation Utilities
// ─────────────────────────────────────────────

export type ValidationErrors = Record<string, string>;

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function isValidPhone(phone: string): boolean {
  return /^[\d\s\(\)\-\+]{7,20}$/.test(phone);
}

export function validateRegistrationForm(data: {
  name: string;
  email: string;
  phone: string;
}): ValidationErrors {
  const errors: ValidationErrors = {};
  if (!data.name.trim()) errors.name = 'Name is required';
  if (!data.email.trim()) {
    errors.email = 'Email is required';
  } else if (!isValidEmail(data.email)) {
    errors.email = 'Enter a valid email address';
  }
  if (data.phone && !isValidPhone(data.phone)) {
    errors.phone = 'Enter a valid phone number';
  }
  return errors;
}

export function validateContactForm(data: {
  name: string;
  email: string;
  message: string;
}): ValidationErrors {
  const errors: ValidationErrors = {};
  if (!data.name.trim()) errors.name = 'Name is required';
  if (!data.email.trim()) {
    errors.email = 'Email is required';
  } else if (!isValidEmail(data.email)) {
    errors.email = 'Enter a valid email address';
  }
  if (!data.message.trim()) errors.message = 'Message is required';
  return errors;
}

export function validateLoginForm(data: {
  email: string;
  password: string;
}): ValidationErrors {
  const errors: ValidationErrors = {};
  if (!data.email.trim()) errors.email = 'Email is required';
  if (!data.password) errors.password = 'Password is required';
  return errors;
}

export function hasErrors(errors: ValidationErrors): boolean {
  return Object.keys(errors).length > 0;
}
